export default {"src":"/_next/static/media/Logo-01.5e7842b0.svg","height":3000,"width":3000};